export default {
    main:{
        colors:{
            1: '#fbca00',
            2: '#bca325',
            3: '#af0000',
            4: '#837f74',
            5: '#b2b1af',
            6:'#cbc5be',
            7: '#d3dbe9',
            8: '#393737',
            9: '#f4265a',
            10: '#a3997e',
            11: '#847c60',
            12: '#65562e',
            13: '#8e793e'
        },
        navBackground:'linear-gradient(to bottom, #1e1c6c, #1e1459 48%, #322257);'
    },

}